import React from "react"
import MFeedMasonryPss from "./m_feed_masonry_pss"
import MScienceCarouselPss from "./m_science_carousel_pss"

const PersonalizedSuggestions = (props) => {
  // TODO: use layout property once it is implemented
  const layout = props.data.suggestions_source

  switch (layout) {
    case "category": {
      return (
        <MFeedMasonryPss
          headline={props.data.headline}
          subheadline={props.data.subheadline}
          source={props.data.suggestions_source || "category"}
          space_before_class={props.data.space_before_class}
          space_after_class={props.data.space_after_class}
        />
      )
    }
    case "tag": {
      return (
        <MScienceCarouselPss
          headline={props.data.headline}
          source={props.data.suggestions_source || "tag"}
          space_before_class={props.data.space_before_class}
          space_after_class={props.data.space_after_class}
        />
      )
    }
    default: {
      return (
        <div>
          Personalized suggestions with layout "{layout}" not implemented.
        </div>
      )
    }
  }
}

export default PersonalizedSuggestions
